import React from "react";

function Home() {
  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h3 className="mt-5">Home Component works!</h3>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
